import { toast } from "react-toastify";
import { i18n } from "../translate/i18n";
import { isString } from "lodash";

const toastError = (err) => {
	// 401 ou 403 decorrentes de sessão expirada são tratados pelo interceptor de autenticação (refresh_token)
	if (err?.response?.status === 401) {
		return;
	}

	const errorMsg = err?.response?.data?.error || err?.response?.data?.message;

	// Sessão expirada, módulo desabilitado ou contato duplicado não exibem toast intrusivo
	if (
		errorMsg === "ERR_SESSION_EXPIRED" ||
		errorMsg === "ERR_ADDON_DISABLED" ||
		(typeof errorMsg === "string" && errorMsg.includes("CONTATO_EXISTE")) ||
		(err?.response?.status === 403 && (!errorMsg || errorMsg === "ERR_SESSION_EXPIRED"))
	) {
		return;
	}

	// Requisições canceladas ou abortadas
	if (err?.name === "CanceledError" || err?.message === "canceled") {
		return;
	}

	if (errorMsg) {
		if (i18n.exists(`backendErrors.${errorMsg}`)) {
			toast.error(i18n.t(`backendErrors.${errorMsg}`), {
				toastId: errorMsg,
				autoClose: 3000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: true,
				progress: undefined,
				theme: "light",
			});
			return;
		} else {
			toast.error(String(errorMsg), {
				toastId: String(errorMsg),
				autoClose: 3000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: true,
				progress: undefined,
				theme: "light",
			});
			return;
		}
	}

	if (isString(err)) {
		toast.error(err);
		return;
	}

	if (err?.message && !err.message.includes("Network Error")) {
		toast.error(err.message);
		return;
	}

	toast.error("Ocorreu um erro inesperado!");
};

export default toastError;
